const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin-pub/search', { params })
  },
  ranking ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin-pub/ranking', { params })
  },
  mediaRanking ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coin/v1frontend/coin-pub/media-ranking', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
